import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { NavigationComponent } from './navigation/navigation.component';
import { appConfig } from './app.config';
import { AppRoutingModule } from './app-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from './http-translate.provider';
import { HttpClient } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatTooltip } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UserOptionsMenuComponent } from './navigation/dialogs/user-options-menu/user-options-menu.component';
import { NotificationsDialogComponent } from './navigation/dialogs/notifications-dialog/notifications-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ErrorService } from './core/services/errors/errorsService';
import { ChangeCompanyComponent } from './navigation/dialogs/change-company/change-company.component';
import { MatSpinner } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [AppComponent, NavigationComponent, UserOptionsMenuComponent, NotificationsDialogComponent, ChangeCompanyComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CoreModule.forRoot(),
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatBadgeModule,
    MatSelectModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    AsyncPipe,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatCardModule,
    MatTooltip,
    MatDialogModule,
    MatSnackBarModule,
    MatSpinner
  ],
  providers: [
    ErrorService,
    ...appConfig.providers,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
